import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { tomiContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";
import Web3 from "web3";

const BalacefAccountTomi = () => {
  const { account } = useWeb3React();
  // const web3 = useWeb3();
  const web3 = new Web3(Environment.rpc);
  const tokenAddress1 = Environment.tomi;
  const contract = tomiContract(tokenAddress1, web3);
  const balacefAccountTomi = useCallback(async () => {
    try {
      const buy = await contract.methods.balanceOf(account).call();
      return buy / 10 ** 18;
    } catch (error) {
      throw error;
    }
  }, [contract, account]);
  return { balacefAccountTomi: balacefAccountTomi };
};
export default BalacefAccountTomi;
